import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import mainlogo from "../../IMG/media/LOGOTYPES/MyActivHub/Web/SVG/logotype_myactivhub_SVG.svg";
import backgroundIMG from "./../../IMG/media/ICONOGRAPHIE/IMAGES/background_home.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { togglePasswordVisibility } from "./LoginUtils";
import { loginAdmin } from "../../AdminAPI/AuthAdmin";

export default function LoginAdmin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [mfa, setMFA] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (
      !username ||
      !password ||
      username === "" ||
      password === "" ||
      username === undefined ||
      password === undefined
    ) {
      setErrorMessage(
        "Veuillez saisir votre nom d'utilisateur et votre mot de passe."
      );
    } else {
      loginAdmin(username, password, mfa)
        .then((data) => {
          const token = data.idToken;
          if (token) {
            navigate("/Admin/");
          } else {
            setErrorMessage(
              "Une erreur s'est produite lors du processus de connexion."
            );
          }
        })
        .catch((error) => {
          console.error(error);
          setErrorMessage("Une erreur s'est produite lors de la connexion.");
        });
    }
  };
  return (
    <div
      className="login-page d-flex justify-content-center align-items-center min-vh-100"
      style={{
        background: `url(${backgroundIMG}) no-repeat center center/cover`,
      }}
    >
      {/* Créditation IA */}
      <div className="img-credit">
        Image générée par MyActivHub en utilisant l'intelligence artificielle
        </div>
      <div className="login-card shadow-lg rounded-4 text-center p-5">
        <div id="login-badge">
          <i
            className="fas fa-chart-line"
            style={{ marginRight: "8px", color: "#5EB66E" }}
          ></i>
          {process.env.REACT_APP_DEV_NAME}
        </div>
        {/* Logo principal */}
        <img src={mainlogo} alt="logo" className="login-logo" />

        {/* Message erreur juste sous logo */}
        {errorMessage && <p className="error-message">{errorMessage}</p>}

          <form
            onSubmit={handleLogin}
          className="w-100 d-flex flex-column align-items-center"
        >
          {/* Utilisateur */}
          <div className="mb-4 w-100 input-group">
            <span className="input-group-text bg-transparent border-0 ps-0 pe-2">
              <i className="fas fa-user text-secondary"></i>
            </span>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              className="form-control rounded-pill"
              placeholder="Utilisateur"
              />
            </div>

          {/* Mot de passe */}
          <div className="mb-4 w-100 input-group position-relative">
            <span className="input-group-text bg-transparent border-0 ps-0 pe-2">
              <i className="fas fa-lock text-secondary"></i>
            </span>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
              className="form-control rounded-pill pe-5"
              placeholder="Mot de passe"
                />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    onClick={() =>
                      togglePasswordVisibility(setShowPassword, showPassword)
                    }
              className="password-icon"
                  />
                </div>

          {/* MFA */}
          <div className="mb-4 w-100 input-group">
            <span className="input-group-text bg-transparent border-0 ps-0 pe-2">
              <i className="fas fa-key text-secondary"></i>
            </span>
              <input
                type="text"
                id="mfa"
                value={mfa}
                onChange={(e) => setMFA(e.target.value)}
              className="form-control rounded-pill"
              placeholder="MFA Code"
              />
            </div>

          {/* Bouton */}
            <button
              type="submit"
            className="btn btn-gradient btn-block w-100 rounded-3"
            >
               Se connecter
            </button>

          <hr className="w-100 my-3" />

          {/* Lien user */}
          <Link to="/" className="user-link">
            Se connecter en tant qu'utilisateur
          </Link>
          </form>
      </div>
    </div>
  );
}
